import { useEffect, useState } from "react";
import { findByTurmaCodigo } from "../api-aluno-foto";
import { errorMessage } from "../../../util/ConfirmAlertUtil";

/** Fotos dos alunos da turma, ordenadas pelo nome do aluno. */
export const useAlunoFotos = (turma) => {
  const [listaAF, setListaAF] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const codTurma = turma?.codigo;

  useEffect(() => {
    setListaAF([]);
    if (!codTurma) return undefined;

    // A API não aceita AbortSignal: ignora respostas de uma turma já trocada.
    let active = true;
    setIsLoading(true);
    findByTurmaCodigo(codTurma)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else if (Array.isArray(data)) {
          // A API pode devolver itens nulos na lista.
          setListaAF(
            data
              .filter(Boolean)
              .sort((a, b) => (a.aluno?.nome ?? "").localeCompare(b.aluno?.nome ?? "", "pt-BR")),
          );
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [codTurma]);

  return { listaAF, isLoading };
};
